import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  onClose: () => void;
}

const ContactUsModal: React.FC<Props> = ({ show, onClose }) => {
  const { t } = useTranslation();
  if (!show) return null;

  const phone = t("contactModal.phone");
  const email = t("contactModal.email");

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-xl bg-white shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-gray-100 px-6 py-4">
          <h4 className="font-semibold text-primary">
            {t("contactModal.title")}
          </h4>
          <p className="mt-0.5 text-sm text-muted">
            {t("contactModal.subtitle")}
          </p>
        </div>

        <div className="space-y-4 px-6 py-5 text-sm">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">
              {t("contactModal.phoneLabel")}
            </p>
            <a
              href={`tel:${phone.replace(/[^\d+]/g, "")}`}
              className="font-medium text-info hover:underline"
            >
              {phone}
            </a>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">
              {t("contactModal.emailLabel")}
            </p>
            <a
              href={`mailto:${email}`}
              className="font-medium text-info hover:underline"
            >
              {email}
            </a>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">
              {t("contactModal.hoursLabel")}
            </p>
            <p className="font-medium text-gray-700">
              {t("contactModal.hours")}
            </p>
          </div>
        </div>

        <div className="flex justify-end border-t border-gray-100 px-6 py-4">
          <button
            type="button"
            className="cursor-pointer rounded-lg bg-primary px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-light"
            onClick={onClose}
          >
            {t("contactModal.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;
